import api from '../api'

export const insert = async (locationId, fleetId, driverAuthorization, dispositionId, ersInstructions) => { 
	
	let resp = await api.service('fleetLocations').find({
		query: {
			id: { $eq: locationId },
			$include: [
				'axleCheckPreference.axleCheckDetails',
			]
		}
	})

	let axleCheckPreferenceId = resp.data[0].axleCheckPreferenceId
	if (axleCheckPreferenceId) {
		let axleCheckDetails = resp.data[0].axleCheckPreference.axleCheckDetails

		if (axleCheckDetails && axleCheckDetails.length > 0) {
			await api.service('axleCheckDetails').patch(axleCheckDetails[0].id, {
				dispositionId: dispositionId
			})
		} else {
			await api.service('axleCheckDetails').create({
				dispositionId: dispositionId,
				preferencesId: axleCheckPreferenceId
			})
		}
	} else {
		const axleCheckPreferencesResponse = await api.service('axleCheckPreferences').create({ fleetId: fleetId })

		await api.service('fleetLocations').patch(locationId, {
			axleCheckPreferenceId: axleCheckPreferencesResponse.id
		})

		await api.service('axleCheckDetails').create({
			dispositionId: dispositionId,
			preferencesId: axleCheckPreferencesResponse.id
		})
	}

	await api.service('fleetLocations').patch(locationId, {
		authorizationPreferenceId: driverAuthorization,
		ersComments: ersInstructions
	})
} 


// WEBPACK FOOTER //
// ./src/database/misc.js